import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBike: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bike"><circle cx="19" cy="15" r="4.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="5" cy="15" r="4.25" stroke="currentColor" strokeWidth="1.5"/><path d="M12.25 12.75L16.5 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M5.75 7.25H8.75M6.75 7.75L12 12.75V15H5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19 15L15.95 4.75H13.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconBike;
